import React from "react";
import { Icon } from "../icons";
import HeaderSubMenuItemSpan from "./HeaderSubMenuItemSpan";
import { FiLock } from "react-icons/fi";

const HeaderSubMenuItem = (props) => {
  const { menu, link, icon, number } = props;
  const renderIcon = () => {
    if (icon === "header-change-password") {
      return <FiLock color="#667085" className="mr-[8px] lg:w-6 lg:h-6 w-[22px] h-[22px]"/>;
    }
    return <Icon name={icon} className="mr-[8px] lg:w-6 lg:h-6 w-[22px] h-[22px]" />;
  };
  return (
    <div>
      <a
        href={link}
        className="flex flex-row lg:px-4 lg:py-3 px-3 py-2 rounded-[8px] bg-[#f2f4f7] hover:bg-[#e3f0fc] "
      >
        {renderIcon()}
        <span className="flex-1 lg:text-base text-[15px]">{menu}</span>
        {number && <HeaderSubMenuItemSpan span={number} />}
      </a>
    </div>
  );
};

export default HeaderSubMenuItem;
